import { useEffect, useRef, useState } from 'react';

export function useCountdown(
  start: number,
  active: boolean = true,
  interval: number = 1000,
  onEnd?: () => void
) {
  const [time, setTime] = useState(start);
  const intervalFn = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!active) {
      return;
    }
    intervalFn.current = setInterval(() => {
      setTime((prev) => {
        if (prev <= 0) {
          clearInterval(intervalFn.current!);
          onEnd?.();
          return 0;
        }
        return prev - 1;
      });
    }, interval);

    return () => {
      clearInterval(intervalFn.current!);
      intervalFn.current = null;
    };
  }, [start, interval, setTime, active]);

  return { time, pause: () => clearInterval(time) };
}
